module.exports = function(type, message, autoRemoveSeconds) {
    var $flash = $(`<div class="alert alert-${type} alert-dismissable">`).text(message);
    $('#flash-container').html('').prepend($flash);

    if (autoRemoveSeconds) {
      window.setTimeout(function(){
        $flash.fadeOut();
      }, autoRemoveSeconds * 1000);
    }
}
